/** logic for pages with menu (dining, spa services, etc) */
import throttle from '../../components/modules/throttle';

const sidebar = document.querySelector('.js-menu-page-sidebar');
const wrapper = document.querySelector('.js-menu-page-wrapper');

let sidebarHeight = 0;
let wrapperHeight = 0;

if (sidebar) {
  sidebarHeight = sidebar.clientHeight;
}

if (wrapper) {
  wrapperHeight = wrapper.clientHeight;
}

window.addEventListener('scroll', throttle(() => {
  if (sidebar) {
    // eslint-disable-next-line max-len
    const offset = Math.abs((sidebar.getBoundingClientRect().top - sidebar.offsetParent.getBoundingClientRect().top)) + sidebarHeight;

    sidebar.classList.toggle('hide', ((offset - wrapperHeight) === 0));
  }
}, 100));

/** keyboard navigation for menu category tabs, per the WAI-ARIA APG tabs pattern */
const tablist = document.querySelector('.menu-page__links[role="tablist"]');

if (tablist) {
  const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));

  const moveFocus = (fromIndex, toIndex) => {
    tabs[fromIndex].setAttribute('tabindex', '-1');
    tabs[toIndex].setAttribute('tabindex', '0');
    tabs[toIndex].focus();
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener('keydown', (event) => {
      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          event.preventDefault();
          moveFocus(index, (index + 1) % tabs.length);
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          event.preventDefault();
          moveFocus(index, (index - 1 + tabs.length) % tabs.length);
          break;
        case 'Home':
          event.preventDefault();
          moveFocus(index, 0);
          break;
        case 'End':
          event.preventDefault();
          moveFocus(index, tabs.length - 1);
          break;
        case ' ':
        case 'Spacebar':
          event.preventDefault();
          if (tab.tagName === 'A' && tab.getAttribute('href')) {
            tab.click();
          }
          break;
        default:
          break;
      }
    });
  });
}
